module.exports = __webpack_public_path__ + "img/8.05373682.jpg";